import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button } from "ui";

function NotFoundPage() {
  const { t } = useTranslation("Shared");
  const navigate = useNavigate();
  return (
    <div className="d-flex flex-column text-center position-absolute top-50 start-50 translate-middle">
      <span className="mx-5 mb-3 mt-0">
        <Trans i18nKey="page_not_found" ns="Shared">
          <strong>404</strong> - Page not found. <br />
          The page you are looking for might have been removed or temporarly
          unavailable.
        </Trans>
      </span>
      <Button onClick={() => navigate(-1)} className="align-self-center">
        {t("buttons.back")}
      </Button>
    </div>
  );
}

export default NotFoundPage;
